// @ts-strict-ignore
import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { DEFAULT_TOOLTIP_CONFIG, TooltipConfig } from '../types';
import { LiveAnnouncer } from '@angular/cdk/a11y';

@Component({
    selector: 'app-tooltip-hint',
    templateUrl: './tooltip-hint.component.html',
    styleUrls: ['./tooltip-hint.component.scss'],
    standalone: false
})
export class TooltipHintComponent {
  @Input() set config(_config: TooltipConfig) {
    this._config = _config;
    this.label = _config.label;
    this._setTooltipClass();
  }

  @ViewChild('tooltip') tooltipRef: ElementRef<HTMLElement>;
  @ViewChild('contentContainer') contentContainerRef: ElementRef<HTMLElement>;
  @ViewChild('content') contentRef: ElementRef<HTMLElement>;

  tooltipClass: string[] = [];
  label: string = '';
  showArrow: boolean = true;

  private _config: TooltipConfig = DEFAULT_TOOLTIP_CONFIG;

  constructor(private liveAnnouncer: LiveAnnouncer) {}

  get id(): string {
    return this._config.id;
  }

  get width(): string {
    return this._config.width;
  }

  ngAfterViewInit() {
    this._adjustContentWidth();
    this.liveAnnouncer.announce(this.label);
  }

  private _adjustContentWidth() {
    if (!this.contentContainerRef || !this.contentRef) {
      return;
    }

    const contentWidth = this.contentRef.nativeElement.getBoundingClientRect().width;
    if (contentWidth > 0) {
      this.contentContainerRef.nativeElement.style.maxWidth = `${Math.ceil(contentWidth)}px`;
    }

    if (this._config.width) {
      const padding = window.getComputedStyle(this.tooltipRef.nativeElement).paddingLeft;
      this.tooltipRef.nativeElement.style.width = `${Math.ceil(contentWidth) + parseInt(padding) * 2}px`;
    }
  }

  private _setTooltipClass() {
    this.tooltipClass = [
      'tooltip',
      `tooltip-${this._config.theme}`,
      `tooltip-${this._config.position}`,
      this._config.linebreaks ? 'linebreaks' : '',
    ];
    this.showArrow = this._config.position !== 'none';
  }
}
